<template>
  <div class="accounts-receivable-settlement">
    <div class="accounts-receivable-settlement-search">
      <div class="screen">
        <el-select 
          class="white w240" 
          clearable 
          filterable
          v-model="screen.projectId" 
          placeholder="请选择项目"
          @change="changeProject"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          class="w240"
          v-model="screen.date"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-select class="white w240"
          v-model="screen.currencySystem" placeholder="请选择币制" @change="changeCurrencySystem">
          <el-option v-for="item in currencySystemList" :key="item.id" :label="item.name"
            :value="item.id"></el-option>
        </el-select>
        <el-button class="btn-blue" @click="onScreen">搜索</el-button>
        <el-button class="btn-white" @click="reset">清空</el-button>
      </div>
    </div>
    
    <div class="accounts-receivable-settlement-content">
      <div class="table-row">
        <div class="title-row">
          <div class="title-content">
            <div class="sub-title">
              进仓费用
            </div>
            <el-input
              class="white"
              placeholder="请输入单号"
              v-model="filterEnterWarehouseOrderText">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <!-- <div class="status-select">
            <div 
              :class="index === activeEnterWarehouseStatusIndex?'status-item status-item-active':'status-item'"
              v-for="(item, index) in statusList"
              :key="index"
              @click="selectEnterWarehouseStatus(item, index)"
            >
              {{ item.name }}
            </div>
          </div> -->
        </div>
        <div class="code-data">
          <div class="code-data-left">
            <el-checkbox 
              class="all-check"
              :indeterminate="enterWarehouseIsIndeterminate" 
              v-model="enterWarehouseCheckAll" 
              @change="handleEnterWarehouseCheckAllChange"
            >
            {{`全选（${checkedEnterWarehouseCodeList.length} / ${enterWarehouseCodeList.length}）`}}
            </el-checkbox>
            <div
              v-for="(item, index) in enterWarehouseCodeList.filter(data => data.code.indexOf(filterEnterWarehouseOrderText) !== -1)" 
              :key="index"
              class="code-main enter-code-main"
              >
              <el-checkbox
                :value="item.checked"
                :label="item.code" 
                :class="item.code === activeEnterWarehouseCode?'code-active':''"
                @change="changeEnterWarehouseCode(item)"
              > 
                <el-tooltip
                  :ref="`enterWarehosCodeRef${item.code}tip`"
                  :content="`${item.code}`"
                  placement="top"
                  :offset="-100"
                  >
                  <!-- :disabled="showTooltip" -->
                  <div slot="content" class="exit-popper-content">
                    <p>进仓单号：</p>
                    {{ item.code }}
                    <img class="copy" src="~assets/images/copy-gray.png" @click="copyText(item.code)">
                  </div>
                  <div :class="item.code === activeEnterWarehouseCode?`tips tips-active tips${item.amount.toString().length }`:`tips tips${item.amount.toString().length }`"
                    @mouseover="onMouseOver(`enterWarehosCodeRef${item.code}`)"
                  >
                    <span :ref="`enterWarehosCodeRef${item.code}`">{{ `${item.code}` }}</span>
                  </div>
                </el-tooltip>
              </el-checkbox>
              <div class="currency-info">
                <img class="currency-img" :src="currencySystemImg[screen.currencySystem]">
                <span>{{ item.amount }}</span>
              </div>
            </div>
          </div>
          <div class="code-data-right">
            <div class="table">
              <el-table
                ref="enterWarehouseMultipleTable"
                :data="enterWarehouseTableData.filter(data => !enterWarehouseStatus || data.status === enterWarehouseStatus)"
                style="width: 100%"
                :row-key="getKey"
                @selection-change="handleSelectionEnterWarehouseChange"
                @select-all="enterWarehouseSelectAll"
              >
                <el-table-column
                  type="selection"
                  :reserve-selection="true"
                  :selectable="enterWarehouseCheckSelectable"
                  width="55">
                </el-table-column>
                <el-table-column 
                  v-for="(item, index) in tableTitle"
                  :key="index"
                  :prop="item.prop" 
                  show-overflow-tooltip
                  :formatter="formatter"
                  :label="item.label">
                    <template slot-scope="scope">
                      <div v-if="item.prop === 'statusVal'" :class="scope.row.status === 1?'status1':'status2'">{{ scope.row.statusVal }}</div>
                      <div v-else 
                      style="
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;"
                      >{{scope.row[item.prop]}}</div>
                    </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <div class="table-row">
        <div class="title-row">
          <div class="title-content">
            <div class="sub-title">
              出仓费用
            </div>
            <el-input
              class="white"
              placeholder="请输入单号"
              v-model="filterExitWarehouseOrderText">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <!-- <div class="status-select">
            <div 
              :class="index === activeExitWarehouseStatusIndex?'status-item status-item-active':'status-item'"
              v-for="(item, index) in statusList"
              :key="index"
              @click="selectExitWarehouseStatus(item, index)"
            >
              {{ item.name }}
            </div>
          </div> -->
        </div>
        <div class="code-data">
          <div class="code-data-left">
            <el-checkbox 
              class="all-check"
              :indeterminate="exitWarehouseIsIndeterminate" 
              v-model="exitWarehouseCheckAll" 
              @change="handleExitWarehouseCheckAllChange"
            >
            {{`全选（${checkedExitWarehouseCodeList.length} / ${exitWarehouseCodeList.length}）`}}
            </el-checkbox>
            <div
              v-for="(item, index) in exitWarehouseCodeList.filter(data => data.code.indexOf(filterExitWarehouseOrderText) !== -1)" 
              :key="index"
              class="code-main enter-code-main"
              >
              <el-checkbox
                :value="item.checked"
                :label="item.code" 
                :class="item.code === activeExitWarehouseStatusIndex?'code-active':''"
                @change="changeExitWarehouseCode(item)"
              > 
                <el-tooltip
                  :ref="`exitWarehosCodeRef${item.code}tip`"
                  :content="`${item.code}`"
                  placement="top"
                  :offset="-100"
                  >
                  <!-- :disabled="showTooltip" -->
                  <div slot="content" class="exit-popper-content">
                    <p>出仓单号：</p>
                    {{ item.code }}
                    <img class="copy" src="~assets/images/copy-gray.png" @click="copyText(item.code)">
                  </div>
                  <div 
                    :class="item.code === activeExitWarehouseCode?`tips tips-active tips${item.amount.toString().length }`:`tips tips${item.amount.toString().length }`"
                    @mouseover="onMouseOver(`exitWarehosCodeRef${item.code}`)"
                  >
                    <span :ref="`exitWarehosCodeRef${item.code}`">{{ `${item.code}` }}</span>
                  </div>
                </el-tooltip>
              </el-checkbox>
              <div class="currency-info">
                <img class="currency-img" :src="currencySystemImg[screen.currencySystem]">
                <span>{{ item.amount}}</span>
              </div>
            </div>
          </div>
          <div class="code-data-right">
            <div class="table">
              <el-table
                ref="exitWarehouseMultipleTable"
                :data="exitWarehouseTableData.filter(data => !exitWarehouseStatus || data.status === exitWarehouseStatus)"
                style="width: 100%"
                :row-key="getKey"
                @selection-change="handleSelectionChange"
                @select-all="exitWarehouseSelectAll"
              >
              <el-table-column
              type="selection"
              :reserve-selection="true"
                  :selectable="exitWarehouseCheckSelectable"
                  width="55">
                </el-table-column>
                <el-table-column 
                v-for="(item, index) in tableTitle"
                :key="index"
                :prop="item.prop" 
                show-overflow-tooltip
                  :formatter="formatter"
                  :label="item.label">
                    <template slot-scope="scope">
                      <div v-if="item.prop === 'statusVal'" :class="scope.row.status === 1?'status1':'status2'">{{ scope.row.statusVal }}</div>
                      <div v-else
                      style="
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;"
                      >{{scope.row[item.prop]}}</div>
                    </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      
      <div class="table-row">
        <div class="title-row">
          <div class="storage-row">
            <div class="sub-title">存储费用</div>
            <el-input
              class="white"
              placeholder="请输入单号"
              v-model="filterStorageOrderText">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <el-date-picker
            class="w200"
            v-model="storageMonth"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份"
            @change="changeMonth"
          ></el-date-picker>
        </div>
        <div class="code-data">
          <div class="code-data-left">
            <el-checkbox 
              class="all-check"
              :indeterminate="storageIsIndeterminate" 
              v-model="storageCheckAll" 
              @change="handleStorageCheckAllChange"
            >
              {{`全选（${checkedStorageCodeList.length} / ${storageCodeList.length}）`}}
            </el-checkbox>
            <el-checkbox-group v-model="checkedHignStorageCodeList" @change="handleCheckedStorageCodeChange">
              <div
                v-for="(item, index) in storageCodeList.filter(data => data.code.indexOf(filterStorageOrderText) !== -1)" 
                :key="index"
                class="code-main enter-code-main"
              >
                <el-checkbox 
                  :label="item.code" 
                  :class="item.code === activeStorageCode?'code-active':''"
                >
                  <el-tooltip
                    :ref="`storageCodeRef${item.code}tip`"
                    :content="`${item.code}`"
                    placement="top"
                    :offset="-100"
                    >
                    <!-- :disabled="showTooltip" -->
                    <div slot="content" class="exit-popper-content">
                      <p>进仓单号：</p>
                      {{ item.code }}
                      <img class="copy" src="~assets/images/copy-gray.png" @click="copyText(item.code)">
                    </div>
                    <div :class="item.code === activeStorageCode?`tips tips-active tips${item.amountStrLength }`:`tips tips${item.amountStrLength }`"
                      @mouseover="onMouseOver(`storageCodeRef${item.code}`)"
                      @click="onActiveStorageCode(item)"
                    >
                      <span :ref="`storageCodeRef${item.code}`">{{ `${item.code}` }}</span>
                    </div>
                  </el-tooltip>
                </el-checkbox>
                <div class="currency-info">
                  <img class="currency-img" :src="currencySystemImg[screen.currencySystem]">
                  <span>{{ item.totalCharge }}</span>
                </div>
              </div>
            </el-checkbox-group>
          </div>
          <div class="code-data-right">
            <div class="table">
              <el-table
                ref="storageMultipleTable"
                :data="storageTableData"
                style="width: 100%"
                >
                <el-table-column 
                v-for="(item, index) in storageFeetableTitle"
                :key="index"
                show-overflow-tooltip
                  :prop="item.prop" 
                  :label="item.label">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="footer">
      <div class="accounts-receivable">
        <span class="accounts-receivable-title">预计应收费用：</span>
        <span v-if="screen.currencySystem === 'CNY'" class="accounts-receivable-content">￥{{ totalRMBAccountsReceivable }}</span>
        <span v-else class="accounts-receivable-content usd-accounts-receivable-content">${{ totalUSDAccountsReceivable }}</span>
      </div>
      <el-button
        :class="disabledSaveRegister?'btn-gray':'btn-blue'"
        :disabled="disabledSaveRegister"
        @click="debounceSaveRegister"
        >
          确认结算
        </el-button
      >
    </div>
  </div>
</template>

<script>
import { keepTwoDecimal, modifyNetTitle } from 'common/js/util'
import StorageFeeMixins from 'common/mixins/storage-fee'
import customizeTree from 'components/base/tree/customize-tree.vue'
import AccountsReceivableSettlement from 'models/accounts-receivable-settlement'
import CurrencyMinxins from "common/mixins/currency";
import ExitWarehouseSettlementMixins from 'common/mixins/exit-warehouse-settlement'
import EnterWarehouseSettlementMixins from 'common/mixins/enter-warehouse-settlement'
import EnterExitWarehouseProjectMixins from 'common/mixins/enter-exit-warehouse-project'
export default {
  mixins: [CurrencyMinxins, EnterWarehouseSettlementMixins, ExitWarehouseSettlementMixins, StorageFeeMixins, EnterExitWarehouseProjectMixins],
  components: {
    customizeTree,
  },

  data() {
    return {
      screen: {
        projectId: "",
        projectName: "",
        date: null,
        currencySystem: 'CNY'
      },
      statusList: [
        {id:0, name: '全部'},
        {id:1, name: '未结算'},
        {id:2, name: '已结算'}
      ],
      tableTitle: [
        { prop: 'feeName', label: '明细' },
        { prop: 'billHeadName', label: '抬头名称/抬头编码' },
        { prop: 'agentBusinessVal', label: '代收代付' },
        { prop: 'currencyVal', label: '币制' },
        { prop: 'statusVal', label: '结算状态' },
        { prop: 'amount', label: '金额' }
      ],
      totalRMBAccountsReceivable: 0,
      totalUSDAccountsReceivable: 0,
      showTooltip: false,
      currencySystemImg: {
        'CNY': require('../../../../assets/images/CNY.png'),
        'USD': require('../../../../assets/images/USD.png')
      },
      // 确认结算按钮是否禁止点击
      disabledSaveRegister: false,
      exitCurrencyInfoWidth: 50,
      // 模糊搜索进仓单号
      filterEnterWarehouseOrderText: '',
      // 模糊搜索出仓单号
      filterExitWarehouseOrderText: '',
      // 模糊搜索存储费用单号
      filterStorageOrderText: ''
    }
  },

  created() {
    modifyNetTitle('应收结算')
    this.initEnterExitWarehouseProjectData();
    this.debounceSaveRegister = this.debounce(() => {
      this.saveRegister()
    }, 1000)
  },

  methods: {
    debounce(fn, delay) {
      let timer = null
      return () => {
        if (timer) {
          clearTimeout(timer)
          console.log('拦截')
          
          this.$message.error('结算中，请稍候。');
        }
        timer = setTimeout(() => {
          console.log('发送')

          fn.apply(this, arguments)
          timer = null
        }, delay)
      }
    },
    changeProject() {
      let obj = this.projectList.find(item => {return item.id === this.screen.projectId})
      this.screen.projectName = obj.name
      if (this.storageMonth) this.initStorageFeeTable()
    },

    changeCurrencySystem() {
      this.initEntryData()
      this.initExitData()
      this.initStorageData()
    },
    
    onScreen() {
      this.initEnterWarehouseTable()
      this.initExitWarehouseTable()
    },
    reset() {
      this.screen = {
        projectId: "",
        projectName: "",
        date: null,
        currencySystem: 'CNY'
      }
    },
    getKey(row) {
      return row.keyId
    },
    formatter(row, column) {
      return row.status
    },
    // 计算预计应收费用
    initTotalAccountsReceivable() {
      this.$nextTick(() => {
        let totalRMBAccountsReceivable = 0
        let totalUSDAccountsReceivable = 0
        this.checkedEnterWarehouseCodeList.map(i => {
          i.subjectList.map(j => {
            if (j.isSelect) {
              if (j.currency === 'CNY') {
                totalRMBAccountsReceivable += j.amount
              } else {
                totalUSDAccountsReceivable += j.amount
              }
            }
          })
        })
        this.exitWarehouseCodeList.map(v => {
          v.subjectList.map(j => {
            if (j.isSelect) {
              if (j.currency === 'CNY') {
                totalRMBAccountsReceivable += j.amount
              } else {
                totalUSDAccountsReceivable += j.amount
              }
            }
          })
        })
        this.checkedStorageCodeList.map(i => {
          if (i.currency === 'CNY') {
            totalRMBAccountsReceivable += i.totalCharge
          } else {
            totalUSDAccountsReceivable += i.totalCharge
          }
        })
        this.totalRMBAccountsReceivable = keepTwoDecimal(totalRMBAccountsReceivable)
        this.totalUSDAccountsReceivable = keepTwoDecimal(totalUSDAccountsReceivable)
      })
    },

    saveRegister() {
      this.disabledSaveRegister = true

      let projectId = this.screen.projectId;
      let projectName = this.screen.projectName;
      let currency = this.screen.currencySystem;
      let balanceBeginDate = this.screen.date ? this.screen.date[0] : '';
      let balanceEndDate = this.screen.date ? this.screen.date[1] : '';
      let rentBalanceMonth = this.storageMonth;
      let importsBillList = []
      this.checkedEnterWarehouseCodeList.map(i => {
        let obj = {}
        obj.inboundOrderNo = i.code
        obj.feeList = []
        i.subjectList.map(j => {
          if (j.isSelect) {
            let obj2 = {}
            obj2.keyword = j.id
            obj2.feeName = j.feeName
            obj2.price = j.amount
            obj2.isAddService = j.isAddService
            obj2.orderFeeId = j.orderFeeId
            obj2.billHeadId = j.billHeadId;
            obj2.agentBusiness = j.agentBusiness;
            obj2.currency = j.currency;
            obj2.isBalance = j.status === 2?true: false
            obj.feeList.push(obj2)
          }
        })
        importsBillList.push(obj)
      })

      let exportsBillList = []
      this.checkedExitWarehouseCodeList.map(i => {
        let obj = {}
        obj.orderNo = i.code
        obj.outboundOrderNo = i.outboundOrderNo
        obj.feeList = []
        i.subjectList.map(j => {
          if (j.isSelect) {
            let obj3 = {}
            obj3.isAddService = j.isAddService
            obj3.orderFeeId = j.orderFeeId
            obj3.agentBusiness = j.agentBusiness;
            obj3.billHeadId = j.billHeadId;
            obj3.currency = j.currency;
            obj3.feeName = j.feeName
            obj3.price = j.amount
            obj3.keyword = j.id
            obj3.isBalance = j.status === 2?true: false
            obj.feeList.push(obj3)
          }
        })
        exportsBillList.push(obj)
      })

      let rentBillList = []
      this.checkedStorageCodeList.map(i => {
        let obj = {}
        obj.batchStockId = i.batchStockId
        obj.inboundOrderNo = i.code
        obj.inboundDate = i.inboundDate
        obj.price = i.totalCharge
        obj.agentBusiness = i.agentBusiness
        obj.billHeadId = i.billHeadId
        obj.currency = i.currency
        obj.price = i.totalCharge
        rentBillList.push(obj)
      })
      let data = {
        projectId,
        projectName,
        balanceBeginDate,
        balanceEndDate,
        rentBalanceMonth,
        currency,
        importsBillList,
        exportsBillList,
        rentBillList
      }
      AccountsReceivableSettlement.postSettlement(data).then(res => {
        if (res.success) {
          this.$message.success('结算成功');
          this.disabledSaveRegister = false
          this.initEnterWarehouseTable()
          this.initExitWarehouseTable()
          if (this.storageMonth) this.initStorageFeeTable()
        } else {
          this.disabledSaveRegister = false
          this.$message.error(res.message);
        }
      });
    },

    onMouseOver(refName) {
      this.showTooltip = false
      const node = this.$refs[refName][0]
      const parentWidth = node.parentNode.offsetWidth
      const contentWidth = node.offsetWidth
      this.showTooltip = contentWidth <= parentWidth
    },
    
    copyText(text) {
      let oInput = document.createElement('input');
      oInput.value = text;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("copy")
      this.$message.success('已复制')
      oInput.remove()
    },
  }
}
</script>

<style lang='scss'>
.accounts-receivable-settlement {
  flex:1;
  background: white;
  border-radius: 8px;
  overflow-y: auto;
  padding-bottom: 80px;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width : 6px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 2px;
    box-shadow: inset 0 0 5px #D3D3D3;
    background: #DCDCDC;
  }
  .w200 {
    width: 200px;
  }
  .accounts-receivable-settlement-search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .screen {
      display: flex;
      padding: 20px;
      .w240 {
        width: 240px;
        margin-right: 20px;
      }
    }
    .operation-btn {
      display: flex;
    }
  }
  .accounts-receivable-settlement-content {
    padding: 0px 32px;
    .table-row {
      margin-bottom: 10px;
      .title-row {
        height: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .storage-row {
          width: 320px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .el-input__prefix, .el-input__suffix {
            top: -4px;
          }
        }
        .title-content {
          width: 320px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .el-input__icon {
            line-height: 32px;
          }
        }
        .sub-title {
          min-width: 80px;
          height: 22px;
          font-size: 16px;
          color: #333333;
          line-height: 28px;
        }
        .status-select {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: 152px;
          height: 32px;
          padding: 4px;
          background: #F2F4F8;
          box-sizing: border-box;
          border-radius: 4px;
          .status-item {
            width: 48px;
            height: 24px;
            line-height: 24px;
            font-size: 12px;
            text-align: center;
            color: #999999;
            border-radius: 4px;
            cursor: pointer;
          }
          .status-item-active {
            color: white;
            background: #2E68EA;
          }
        }
      }
  
      .code-data {
        height: 240px;
        margin-top: 8px;
        display: flex;
        justify-content: flex-start;
        .el-checkbox__input.is-focus .el-checkbox__inner,
        .el-checkbox__inner:hover {
          border-color: #2E68EA;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner, 
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #2E68EA;
          border-color: #2E68EA;
        }
        .code-data-left {
          width: 320px;
          height: 100%;
          padding: 10px;
          margin-right: 8px;
          background: #FFFFFF;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #EEEEEE;
          box-sizing: border-box;
          overflow-y: auto;
          .all-check {
            width: 100%;
            height: 32px;
            line-height: 32px;
            padding-left: 8px;
            box-sizing: border-box;
            background: #F9F9F9;
            font-size: 14px;
            border-radius: 4px 4px 4px 4px;
            margin-bottom: 4px;
          }
          .el-checkbox__input {
            height: 14px;
          }
          .el-checkbox__label {
            padding-left: 3px;
          }
          .el-checkbox__label,
          .el-checkbox__input.is-checked+.el-checkbox__label {
            color: #666666;
            font-size: 14px;
          }
          .code-main {
            width: 100%;
            height: 32px;
            padding: 0px 8px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            box-sizing: border-box;
            .el-checkbox {
              display: flex;
              align-items: center;
            }
            .tips {
              // width: 162px;
              color: #666666;
              font-size: 14px;
              cursor: pointer;
              margin-left: 3px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            .tips1,
            .tips2,
            .tips3,
            .tips4 {
              max-width: 192px;
            }
            .tips5 {
              max-width: 187px;
            }
            .tips6 {
              max-width: 179px;
            }
            .tips7 {
              max-width: 170px;
            }
            .tips8 {
              max-width: 162px;
            }
            .tips9 {
              max-width: 154px;
            }
            .tips10 {
              max-width: 146px;
            }
            .tips11 {
              max-width: 138px;
            }
            .tips-active {
              color: #2E68EA;
            }
            .currency-info {
              min-width: 50px;
              max-width: 114px;
              padding: 4px;
              background: #F9F9F9;
              border-radius: 4px;
              margin-left: 8px;
              float: left;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              .currency-img {
                width: 16px;
                height: 16px;
                margin-right: 2px;
              }
              span {
                font-size: 14px;
                line-height: 14px;
                color: #666666;
                font-family: 'PingFang SC-Regular';
                font-weight: 400;
              }
            }
          }
          .enter-code-main {
            .el-checkbox {
              align-items: flex-start;
              .el-checkbox__input {
                margin-top: 2px;
              }
            }
          }
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width : 4px;  /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 2px;
            box-shadow: inset 0 0 5px #D3D3D3;
            background: #DCDCDC;
          }
        }
        .code-data-right {
          flex: 1;
          overflow-y: auto;
          .status1,
          .status2 {
            width: 48px;
            height: 24px;
            line-height: 24px;
            font-size: 12px;
            color: #666666;
            text-align: center;
            background: #F5F5F5;
            border-radius: 4px 4px 4px 4px;
          }
          .status2 {
            background: rgba($color: #22A979, $alpha: 0.12);
            color: #22A979;
          }
          
          .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
            display: flex;
            align-items: center;
          }
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width : 4px;  /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 2px;
            box-shadow: inset 0 0 5px #D3D3D3;
            background: #DCDCDC;
          }
        }
      }
    }
    
  }
  .footer {
    position: fixed;
    background: white;
    width: calc(100% - 232px);
    bottom: 46px;
    left: 216px;
    height: 66px;
    padding: 0px 32px;
    z-index: 9;
    overflow: hidden;
    border-radius: 0px 0px 8px 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px -3px 12px 0px rgba(51, 51, 51, 0.06);
    .accounts-receivable {
      font-weight: 800;
      font-size: 16px;
      .accounts-receivable-title {
        color: #333333;
      }
      .accounts-receivable-content {
        color: #2E68EA;
      }
      .usd-accounts-receivable-content {
        margin-left: 10px;
      }
    }
  }
}
.el-tooltip__popper.is-dark {
  top: -500px;
  background: #333;
  opacity: 0.8;
}
.el-tooltip__popper {
  .exit-popper-content {
    width: 200px;
    font-family: 'PingFang SC-Regular';
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 18px;
    .copy {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
